var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBoardViewIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 33,
    viewBox: "0 0 33 33",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9665_12350)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 8.5H10.5C9.39543 8.5 8.5 9.39543 8.5 10.5V22.5C8.5 23.6046 9.39543 24.5 10.5 24.5H12.5C13.6046 24.5 14.5 23.6046 14.5 22.5V10.5C14.5 9.39543 13.6046 8.5 12.5 8.5Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.5 8.5H20.5C19.3954 8.5 18.5 9.39543 18.5 10.5V16.5C18.5 17.6046 19.3954 18.5 20.5 18.5H22.5C23.6046 18.5 24.5 17.6046 24.5 16.5V10.5C24.5 9.39543 23.6046 8.5 22.5 8.5Z",
    stroke: "#667085",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(4.5 4.5)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBoardViewIcon);
export default __webpack_public_path__ + "static/media/board-view-icon.3ef2fa33eca356a697ab62d307534700.svg";
export { ForwardRef as ReactComponent };